import {
  React,
  Component,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  Paper,
  SelectField,
  MenuItem,
  Divider,
} from 'material-ui';

import {
  PrimaryButton,
} from 'imports/DesignImports';

const styles = {
  paper: {
    padding: '1em'
  },
  selectContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    marginRight: '1em',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1em',
  },
}

class ChangeCompanyStage extends Component {
  constructor(props){
    super(props);
    this.state = {
      selectedCompany: props.companies[0],
      selectedStage: props.stages[0],
      token: this.props.cookies.get('token'),
    }
  }
  render() {
    return (
      <div>
        <Paper zDepth={1} style={styles.paper}>
          <div style={styles.selectContainer}>
            <h3 style={styles.label}>Selecciona una empresa</h3>
            <SelectField
              style={styles.selectField}
              value={this.state.selectedCompany}
              onChange={this.handleCompanySelectChange}
              >
              {this.props.companies.map((company) => {
                return(<MenuItem key={company.id} value={company} primaryText={company.name} styles={styles.menuItem}/>)
              })}
            </SelectField>
          </div>
          <Divider/>
          <h3 style={styles.label}>Etapa actual:
            {' ' + this.state.selectedCompany.current_stages[this.state.selectedCompany.current_stages.length - 1].stage.order + '.- ' +
            this.state.selectedCompany.current_stages[this.state.selectedCompany.current_stages.length - 1].stage.full_name}
          </h3>
          <div style={styles.selectContainer}>
            <h3 style={styles.label}>Cambiar a etapa a: </h3>
            <SelectField
              style={styles.selectField}
              value={this.state.selectedStage}
              onChange={this.handleStageSelectChange}
              >
              {this.props.stages.map((stage, i) => {
                return(<MenuItem key={stage.id} value={stage} primaryText={stage.order + '.- ' + stage.full_name} styles={styles.menuItem}/>)
              })}
            </SelectField>
          </div>
        </Paper>
        <div style={styles.buttonContainer}>
          <PrimaryButton label='Cambiar etapa' onClick={this.changeStage} />
        </div>
      </div>
    );
  }

  handleCompanySelectChange = (event, index, value) => {
    this.setState({selectedCompany: value});
  }

  handleStageSelectChange = (event, index, value) => {
    this.setState({selectedStage: value});
  }

  changeStage = () => {
    this.props.raiseLoading();
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });

    connection.patch(routes.changeStage(this.state.selectedCompany.id), this.state.selectedStage)
    .then((response) => {
      this.props.raiseAlertOneButton('¡Éxito!', 'Has cambiado la etapa en la que se encuentra la empresa sin problemas')
    })
    .catch((err) => {
      this.props.raiseAlertOneButton('¡Error!', 'Hubo un problema al cambiar la etapa en la que se encuentra la empresa, intenta nuevamente')
    })
  }
}

export default ChangeCompanyStage;



// WEBPACK FOOTER //
// ./src/components/administration/ChangeCompanyStage.js